import $ from 'jquery';
import * as variables from 'variables';
import sendEventToGoogleAnalytics from 'utils/googleAnalytics';
import laodBannerNewsSchedule from 'utils/loadBannerNewsSchedule';

const relatedDocumentsTemplate = require('related-documents-template.dust');
const scheduleDetailTemplate = require('schedule-detail-template.dust');
const bannerTemplate = require('banner-template.dust');

export default function displayScheduleDetailCMS(context, id) {
	$.getJSON(`${variables.directioCMSapiService}schedule/GetDetail/${id}?callback=?&t=${new Date().getTime()}`).done((data) => {
		scheduleDetailTemplate(data.entities, (err, out) => {
			context.app.swap('');
			context.$element().append(out);
			relatedDocumentsTemplate(data.entities, (err2, out2) => {
				$('.multimedia-detail-cri').append(out2);
			});
			laodBannerNewsSchedule((err3, data2) => {
				if (!err3) {
					bannerTemplate(data2, (err4, out3) => {
						$('.multimedia-detail-cri').prepend(out3);
					});
				}
			});
		});
	}).fail((jqXHR, textStatus, errorThrown) => {
		sendEventToGoogleAnalytics('Client-Error', 'ajax', `${jqXHR.getAllResponseHeaders()} ${textStatus} ${errorThrown.message}`);
	}).always(() => {
		variables.$doc.trigger('view.loaded');
	});
}



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/displayScheduleDetailCMS.js
 **/